import gql from "graphql-tag";

export const productLensTypeFragment = gql`
  fragment ProductLensTypeFragment on ProductLensType {
    id
    name
    extraChargeCode
    skuStartCode
    sortOrder
    isActive
    sortOrder
  }
`;
